var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_7308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1543 19.7486L31.8336 25.0971L38.1257 29.1182L39.2229 19.7815L38.1257 10.6533L31.7129 14.1861L27.1543 19.7486Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 28.2514V36.2057C0 38.0242 1.47291 39.4971 3.29143 39.4971H11.2457L12.8914 33.4848L11.2457 28.2514L5.78743 26.6057L0 28.2514Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2457 0L0 11.2457L5.78743 12.8914L11.2457 11.2457L12.864 6.08366L11.2457 0Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2457 11.2457H0V28.2514H11.2457V11.2457Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.312 4.7616L38.1257 10.6533V29.1182L45.3449 35.0373C46.4256 35.8821 48.0055 35.1113 48.0055 33.7372V6.03429C48.0055 4.64366 46.39 3.88115 45.312 4.7616ZM27.1543 19.7486V28.2514H11.2457V39.4972H34.8343C36.6528 39.4972 38.1257 38.0242 38.1257 36.2057V29.1182L27.1543 19.7486Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8343 0H11.2457V11.2457H27.1543V19.7486L38.1257 10.6587V3.29143C38.1257 1.47291 36.6528 0 34.8343 0Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_7308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 39.4971,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/google-meet.50df7857bfaf35ac5ebbfd6601df7193.svg";
export { ForwardRef as ReactComponent };